var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useStore } from '@/store';
import eventBus from '@/services/EventBus';
class KlarnaService {
    constructor() {
        this.start_ready = false;
        this.init_ready = false;
    }
    start() {
        return new Promise((resolve) => {
            $.getScript('https://x.klarnacdn.net/kp/lib/v1/api.js', () => {
                this.start_ready = true;
                resolve();
            });
        });
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const token = (_b = (_a = useStore().state.blue.additional_payment_info) === null || _a === void 0 ? void 0 : _a.klarna) === null || _b === void 0 ? void 0 : _b.token;
            if (!token) {
                throw new Error('Nicht ohne Token!');
            }
            if (!this.start_ready) {
                yield this.start();
            }
            Klarna.Payments.init({
                client_token: token,
            });
            this.init_ready = true;
        });
    }
    submit(cart) {
        if (!cart.payment_type_id.startsWith('klarna_')) {
            return Promise.reject('Nicht Klarna!');
        }
        return this.load(cart.payment_type_id.replace('klarna_', ''))
            .catch(() => {
            eventBus.emit('openInfoPopup', {
                icon: 'error',
                headline: 'Klarna',
                message: 'Leider ist ein Fehler bei Klarna aufgetreten.',
            });
            return false;
        })
            .then(() => true);
    }
    load(payment_name) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
            if (!this.init_ready) {
                yield this.init();
            }
            Klarna.Payments.on('fullscreenOverlayShown', () => {
                resolve();
            });
            Klarna.Payments.load({
                container: '#klarna-payments-container',
                payment_method_category: payment_name,
            }, {}, () => {
                this.authorize(payment_name);
            });
        }));
    }
    authorize(payment_name) {
        Klarna.Payments.authorize({
            payment_method_category: payment_name,
        }, {}, function (res) {
            if (res.approved) {
                window.location.href = '/kaufen/checkout/klarna_callback/' + res.authorization_token;
            }
        });
    }
}
const klarnaService = new KlarnaService();
export default klarnaService;
useStore().watch((state) => { var _a, _b; return (_b = (_a = state.blue.additional_payment_info) === null || _a === void 0 ? void 0 : _a.klarna) === null || _b === void 0 ? void 0 : _b.token; }, function () {
    klarnaService.init();
});
